import { Injectable } from '@angular/core';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class VariablesService {
  constructor() {}

  test = 'test';

  VARIABLE = {
    REGCODE: { ID: 22 },
    FIRST_TIME: {
      ID: 18,
      summaryDisplayLabel: 'firsttimesummary',
      displayOnSummary: true,
      convert: 'yesno'
    },
    BEST_FEATURES: {
      ID: 140,
      summaryDisplayLabel: 'bestfeature',
      displayOnSummary: true,
      summaryDisplayWhenNoData: true,
      summaryNoDataText: 'Unanswered',
      convert: 'checkbox'
    },
    BEST_FEATURES_OTHER: {
      ID: 150,
      displayOnSummary: true,
      appendToID: 14,
      replaceText: 'Other'
    },
    LANGUAGE_INTERPRETER: { ID: 1 },
    BEDDING_PREFERENCE: {ID: 2},
    EXTENSION_OPTIONS: { ID: 56 },
    OTHER_NUMBER: { ID: 72 },
    ROOMMATE_NAME: { ID: 3 },
    ROOMMATE_EMAIL: { ID: 4},
    ROOMMATE_ARRIVAL: { ID: 5},
    ROOMMATE_DEPARTURE: { ID: 6},
    GUEST_CITY: { ID: 7},
    GUEST_STATE: { ID: 8},
    WEALTH_MANAGEMENT_FIRM: { ID: 9},
    WEALTH_MANAGEMENT_FIRM_QUALIFICATION_LEVEL: { ID: 10},
    CFP: { ID: 11},
    FIELD_MANAGER: { ID: 12},
    ADVISE_BOARD_COUNCIL: { ID: 13},
    CFP_NUMBER: { ID: 14},
    OSJ: { ID: 15},
    REPID: { ID: 16},
    NUERODIVERSITY_CONSIDERATIONA: { ID: 17},
    AGE_RANGE: { ID: 19},
    GENDER: { ID: 20},
    ETHNICITY: { ID: 21},
    BUSINESS_JOB_ROLL: { ID: 22},
    NUMBER_OF_EMPLOYEES: { ID: 23},
    FINANCIAL_EXPERIENCE: { ID: 24},
    AVERAGE_AUM: { ID: 25},
    BUSINESS_AFFILIATION: { ID: 26},
    IS_ALTERNATIVE_INVESTMENTS: { ID: 27},
    IS_BUFFERED_PRODUCTS: { ID: 28},
    IS_EMPLOYER_RETIREMENT_PLANS: { ID: 29},
    IS_ETFS: { ID: 30},
    IS_HIGH_NET_WORTH: { ID: 31},
    IS_MODELS: { ID: 32},
    IS_SMAS: { ID: 33},
    AI_VEHICLES: { ID: 34},
    SMA_STRATEGIES: { ID: 35},
    DC_BREAKOUT_SESSIONS: { ID: 36},
    DC_CE_CREDITS: { ID: 37},
    PREFERRED_CONTACT: { ID: 38},
    OSAIC_ANTI_HARASSMENT_POLICY: { ID: 39},
    OSAIC_PHOTO_VIDEO_RELEASE: { ID: 40},
    OSAIC_DONATION: { ID: 41},
    BRAINDATE_AMBASSADOR: { ID: 42},
    HOTEL_BENEFIT_NIGHTS: { ID: 43},
    DEPARTMENT_NAME: { ID: 44},
    // NO_HOTEL_REASON: {ID: 2, summaryDisplayLabel: "nohotellabel", displayOnSummary:true, page:"hotel"}
  };

  toCheckBoxModel(actual, keys, delimiters?) {
    if (!keys) {
      return undefined;
    }
    const model = {};
    if (!actual) {
      return model;
    }
    const split = actual.split(delimiters ? delimiters : /,+ */);
    return _.values(keys).reduce((a, c) => {
      a[c] = split.indexOf(c) >= 0;
      return a;
    }, model);
  }

  toDelimitedKeysString(c, delimiters?) {
    if (!c) {
      return '';
    }
    return _.keys(c)
      .filter(k => {
        return c[k];
      })
      .join(delimiters ? delimiters : ', ');
  }
}
